/* eslint-disable jsx-a11y/anchor-is-valid */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */
import Link from 'next/link';

import { determineDestination } from '@/components/common/utils';

import type { MouseEvent, ReactNode } from 'react';

export const mobileNavHeight = '65px';

export type Theme = 'light' | 'dark';

interface NavLinkProps {
  href: string;
  ariaLabel?: string;
  children?: ReactNode;
  className?: string;
  target?: '_blank';
  rel?: 'noopener';
  onMouseEnter?: (event: MouseEvent<HTMLAnchorElement>) => void;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export const NavLink = ({
  href,
  ariaLabel,
  children,
  className,
  onMouseEnter,
  onClick,
}: NavLinkProps) => {
  const destination = determineDestination(href, false);
  return (
    <Link
      href={href}
      onMouseEnter={onMouseEnter}
      className={className}
      target={destination.target}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export interface LinkProps {
  href: string;
  label: string;
  description?: string;
  isExternal?: boolean;
}

export const aboutLinks = (locale: string): LinkProps[] => {
  switch (locale) {
    case 'en-GB':
      return gbAboutLinks;
    case 'en-US':
      return usAboutLinks;
    default:
      return gbAboutLinks;
  }
};
export const usAboutLinks: LinkProps[] = [
  { href: '/about', label: 'Our Mission', description: '' },
  {
    href: '/blog',
    label: 'Blog',
    description: '',
  },
  {
    href: '/diversity',
    label: 'Diversity, Equity and Inclusion',
    description: '',
  },
];
export const gbAboutLinks: LinkProps[] = [
  { href: '/about', label: 'Our Mission', description: '' },
  {
    href: '/blog',
    label: 'Blog',
    description: '',
  },
  {
    href: '/diversity',
    label: 'Diversity, Equity and Inclusion',
    description: '',
  },
];

export const candidateLinks = (locale: string): LinkProps[] => {
  switch (locale) {
    case 'en-GB':
      return gbCandidateLinks;
    case 'en-US':
      return usCandidateLinks;
    default:
      return gbCandidateLinks;
  }
};

const gbCandidateLinks = [
  {
    href: '/young-adults',
    label: 'Start your career',
    description:
      "Earn a £18000+ salary whilst you learn at the world's top companies",
  },
  {
    href: '/professionals',
    label: 'Learn new skills',
    description: 'Develop new skills and competencies for the digital economy',
  },
];

const usCandidateLinks = [
  {
    href: '/young-adults',
    label: 'Start your career',
    description: "Earn while you learn at the world's top companies",
  },
  {
    href: '/professionals',
    label: 'Learn new skills',
    description: 'Develop new skills and competencies for the digital economy',
  },
];
